const timelineItems = [
  {
    id: 1,
    start: "2021-01-14",
    end: "2021-01-22",
    name: "Recruit translators",
  },
  {
    id: 2,
    start: "2021-01-17",
    end: "2021-01-31",
    name: "Create lesson plan 1",
  },
  {
    id: 3,
    start: "2021-02-05",
    end: "2021-02-13",
    name: "Translate phrases for lesson 1",
  },
  {
    id: 4,
    start: "2021-02-07",
    end: "2021-03-08",
    name: "Create dark mode design",
  },
  {
    id: 5,
    start: "2021-02-14",
    end: "2021-02-22",
    name: "Recruit copyeditors",
  },
  {
    id: 6,
    start: "2021-02-18",
    end: "2021-02-24",
    name: "Proofread translations for lesson 1",
  },
  {
    id: 7,
    start: "2021-02-20",
    end: "2021-02-22",
    name: "Finalize logo",
  },
  {
    id: 8,
    start: "2021-02-21",
    end: "2021-03-22",
    name: "Implement dark mode",
  },
  {
    id: 9,
    start: "2021-02-21",
    end: "2021-02-28",
    name: "Finalize lesson plan 1",
  },
  {
    id: 10,
    start: "2021-02-23",
    end: "2021-02-23",
    name: "Approve logo",
  },
  {
    id: 11,
    start: "2021-03-03",
    end: "2021-03-29",
    name: "Create lesson plan 2",
  },
  {
    id: 12,
    start: "2021-03-30",
    end: "2021-04-08",
    name: "Translate phrases for lesson 2",
  },
  {
    id: 13,
    start: "2021-04-01",
    end: "2021-04-04",
    name: "Debug mobile notification error",
  },
  {
    id: 14,
    start: "2021-04-05",
    end: "2021-04-06",
    name: "Test debugged mobile notifications",
  },
  {
    id: 15,
    start: "2021-04-16",
    end: "2021-04-30",
    name: "Beta test",
  },
  {
    id: 16,
    start: "2021-05-01",
    end: "2021-05-01",
    name: "Launch day",
  },
];

export default timelineItems;
